// extracted by mini-css-extract-plugin
export default {"slots-category":"hot_slots-category__PuKMW","sports-button":"hot_sports-button__Mucz+"};